import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@liza/ui/components/ui/alert-dialog';
import { useTranslation } from 'react-i18next';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  memberName: string | null;
  isPending: boolean;
  onConfirm: () => void;
};

/** Confirms ending an external provider's participation on the patient's care team (never deletes the provider). */
export const UnlinkExternalProviderConfirmDialog = ({
  open,
  onOpenChange,
  memberName,
  isPending,
  onConfirm,
}: Props): React.ReactElement => {
  const { t } = useTranslation('common');
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {memberName ? t('confirmUnlinkExternalProviderTitle', { name: memberName }) : ''}
          </AlertDialogTitle>
          <AlertDialogDescription>{t('confirmUnlinkExternalProviderDescription')}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="cancel-unlink-external-provider-button">{t('cancel')}</AlertDialogCancel>
          <AlertDialogAction
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            disabled={isPending}
            onClick={onConfirm}
            data-testid="confirm-unlink-external-provider-button"
          >
            {t('remove')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
